import comjs from "@/common/comjs";
import cmfnt from "@/common/cmfnt";
import utils from "@/common/utils";
import validates from "@/common/validates";
export { exportFormDetailAsImage, exportFormDetailAsPDF } from "@/common/formDetailExportUtils";
export default {
  comjs,
  cmfnt,
  utils,
  validates
}
